import React, { Component } from 'react';
import { connect } from 'react-redux';

import Button from 'material-ui/Button';

import BlockInstruction from './BlockInstruction';
import ExerciseRepTable from '../Exercise/ExerciseRepTable';
import MegaDrop from '../MegaDrop/MegaDrop';

import * as DesignerState from '../../../../state/reducer/designer/designer';
import * as Utils from '../../../../lib/designerUtils';
import Console from '../../../../lib/debug';

class BlockTableContents extends Component {
    state = {
        selectedTags: []
    };
    create(newValue, type) {
        let block = this.props.block;
        let exercise = this.props.exercise || {
            title: '',
            eType: 'e',
            tags: [],
            exercises: []
        };

        if (type === 'exercise') {
            DesignerState.toggleExerciseDialog(block, exercise, true, true);
        } else {
            this.props.circuitCreate();
        }
    }
    enableEditing() {
        let block = this.props.block;
        let dispatch = this.props.dispatch;

        DesignerState.enableEditing(dispatch, block);
    }
    async exerciseAdd(exercise) {
        let block = this.props.block;
        let dispatch = this.props.dispatch;

        if (exercise.eType === 'wc') {
            DesignerState.setBlockPlainText(dispatch, block, exercise);
        } else {
            if (!block.id) {
                const blockId = await DesignerState.waitForBlockId(block.key);
                block = { ...block, id: blockId };
            }
            DesignerState.createSetExercise(block, exercise);
        }
    }
    filterByTags(_tags) {
        let exerciseOptions =
            (this.props.exerciseRef.options
                ? this.props.exerciseRef.options
                : this.props.exerciseRef) || [];
        let circuitOptions = this.props.exerciseBenchmarkRef.options || [];
        let allOptions = [...exerciseOptions, ...circuitOptions];
        return Utils.filterOptionsByTags(allOptions, _tags);
    }
    filterUpdate(newValue) {
        let dispatch = this.props.dispatch;
        let block = this.props.block;
        DesignerState.updateExerciseTags(dispatch, block, newValue);

        this.setState(() => ({
            selectedTags: newValue
        }));
    }
    getExerciseTags(tags) {
        let newTags = tags.length ? tags.slice(0) : [];
        if (newTags.length > 3) {
            newTags.splice(3, newTags.length - 3);
        }
        return newTags;
    }
    getOptions() {
        let block = this.props.block;
        if (!block.tags || (block.tags && block.tags.length === 0)) {
            return this.filterByTags(this.state.selectedTags);
        }
        return this.filterByTags(block.tags);
    }
    render() {
        Console.render('designer.BlockTableContents');
        let dispatch = this.props.dispatch;
        let session = this.props.session;
        let block = this.props.block;
        let setExercises = this.props.elements;
        let blockEditing = this.props.blockEditing;

        let exerciseSearch = null;
        if (block.exerciseKeys.length === 0) {
            let blockTitle = Utils.getBlockTitle(
                session.setKeys.indexOf(block.key)
            );
            let exerciseOptions =
                (this.props.exerciseRef.options
                    ? this.props.exerciseRef.options
                    : this.props.exerciseRef) || [];
            let circuitOptions = this.props.exerciseBenchmarkRef.options || [];
            let allOptions = this.getOptions();
            exerciseSearch = (
                <div className="exercise last-row pre-selection">
                    <div className="exercise-search">
                        <span className="exercise-subtitle">{blockTitle}</span>
                        <div className="exercise-select">
                            <MegaDrop
                                type="exercise"
                                auto={true}
                                extra={true}
                                placeholder="Select Exercise or Circuit"
                                blockIsSaving={this.props.blockSaving}
                                selectedTags={this.state.selectedTags}
                                options={allOptions}
                                optionsRef={[
                                    ...exerciseOptions,
                                    ...circuitOptions
                                ]}
                                tags={this.props.tagRef}
                                itemSelect={this.exerciseAdd.bind(this)}
                                handleTags={this.filterUpdate.bind(this)}
                                createItem={this.create.bind(this)}
                            />
                        </div>
                    </div>
                    <div className="exercise-tables">
                        <ExerciseRepTable
                            ref={component => (this.$scheme = component)}
                            block={block}
                            exercise={{}}
                            session={session}
                            disabled={true}
                        />
                    </div>
                </div>
            );
        }

        if (!blockEditing && block.exerciseKeys.length === 0) {
            let blockTitle = Utils.getBlockTitle(
                session.setKeys.indexOf(block.key)
            );
            const classes = 'layout-row layout-align-space-between-center';
            exerciseSearch = (
                <div className="exercise last-row">
                    <div className={classes}>
                        <div className="exercise-search ">
                            <span className="exercise-subtitle">
                                {blockTitle}
                            </span>
                            <div className="exercise-select">
                                <Button
                                    className="flat-button"
                                    variant="raised"
                                    onClick={this.enableEditing.bind(this)}
                                >
                                    Add Exercise
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }

        if (this.props.blockSaving && block.exerciseKeys.length === 0) {
            exerciseSearch = (
                <div className="exercise last-row block-saving">
                    <div className="header">
                        <div className="left-option" />
                        <div className="right-option" />
                    </div>
                </div>
            );
        }

        return (
            <div>
                <BlockInstruction block={block} dispatch={dispatch} />
                {setExercises}
                {exerciseSearch}
            </div>
        );
    }
}

const mapStateToBlockTableProps = (state, ownProps) => {
    return {
        ...ownProps,
        blockSaving: state.calendar.uiTree.blockSaving === ownProps.block.key,
        blockEditing:
            state.calendar.uiTree.blockEditingKey === ownProps.block.key,
        tagRef: state.calendar.uiTree.exerciseTags,
        exerciseBenchmarkRef: state.library.exerciseBenchmarkRef,
        exerciseRef: state.library.exerciseRef
    };
};

export default connect(mapStateToBlockTableProps)(BlockTableContents);
